import React from 'react'
import {
  Box,
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  Text,
} from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { StepBreadcrumbs } from '../StepBreadcrumbs'
import { FulfillmentOutlet, STEPS } from '../types'
import { useVdFeatureManager } from '../../../../../../ng-compat/hooks'
import { FulfilmentType } from '../../../../../../models/fulfilment'
import { FulfilmentSelect } from './FulfillmentSelect'
import { OutletToFulfilFrom } from './OutletToFulfilFrom'

interface Props {
  onStepChange: (step: STEPS) => void
  onTypeChange: (type: FulfilmentType) => void
  onOutletChange: (outlet: string) => void
  type: FulfilmentType
  outlets: FulfillmentOutlet[]
  onClose: () => void
  currentOutlet: string
  totalQuantity: number
}

export const Step1: React.FC<Props> = ({
  onStepChange,
  onClose,
  type,
  outlets,
  onTypeChange,
  onOutletChange,
  currentOutlet,
  totalQuantity,
}) => {
  const vdFeatureManager = useVdFeatureManager()
  const shouldShowOutletPicker = vdFeatureManager.get(
    'fulfill_from_another_outlet'
  )
  const fulfilmentLif = vdFeatureManager.get('fulfillment_lif')

  const t = useT()

  return (
    <Modal size="small" onClose={onClose}>
      <StepBreadcrumbs step={STEPS.METHOD} />
      {fulfilmentLif ? (
        <ModalHeader>
          {t(
            '{totalQuantity, plural, one {Choose how the {totalQuantity} item in this sale will be fulfilled} other {Choose how all {totalQuantity} items in this sale will be fulfilled}}',
            { totalQuantity, _context: 'Mark as unfulfilled modal header' }
          )}

          <Text tag="p" className="vd-mt2">
            {t(
              'Only one fulfilment method can be selected for items that require fulfillment. To record another method, create another sale.',
              { _context: 'Mark as unfulfilled modal header description' }
            )}
          </Text>
        </ModalHeader>
      ) : (
        <ModalHeader>
          {t('Choose how this order will be fulfilled.', {
            _context: 'Mark as unfulfilled modal header',
          })}
          <Text tag="p" className="vd-mt2">
            {t('Inventory will be reserved for all items in the sale.', {
              _context: 'Mark as unfulfilled modal header description',
            })}
          </Text>
        </ModalHeader>
      )}
      <ModalContent>
        <>
          <FulfilmentSelect defaultType={type} onTypeChange={onTypeChange} />
          {shouldShowOutletPicker && (
            <OutletToFulfilFrom
              outlets={outlets}
              onOutletChange={onOutletChange}
              className="vd-mt5"
              currentOutlet={currentOutlet}
            />
          )}
        </>
      </ModalContent>
      <ModalActions>
        <Box className="vd-btn-group">
          <Button onClick={() => onClose()} variant="supplementary">
            {t('Don’t mark as unfulfilled', {
              _context: 'Mark as unfulfilled modal',
            })}
          </Button>
          <Button onClick={() => onStepChange(STEPS.CUSTOMER)} variant="go">
            {t('Next', { _context: 'Mark as unfulfilled modal' })}
          </Button>
        </Box>
      </ModalActions>
    </Modal>
  )
}

Step1.displayName = 'Step1'
